import { getMetaContent } from "./meta";

const SIGN_OUT_PATH = "/users/sign_out";
const ALT_ENV_AFTER_SIGN_OUT_PATH = "/";
const ENV = window.HA_CONF?.ENV;
const HOST_URL = window.HA_CONF?.HOST_URL;
const PRODUCTION_AFTER_SIGN_OUT_PATH = `https://${HOST_URL}/sign-out`;

const getAfterSignOutPath = () => {
  return ENV == "production"
    ? PRODUCTION_AFTER_SIGN_OUT_PATH
    : ALT_ENV_AFTER_SIGN_OUT_PATH;
};

const logout = () => {
  return fetch(SIGN_OUT_PATH, {
    method: "delete",
    body: JSON.stringify({
      authenticity_token: getMetaContent("csrf-token"),
      _method: "delete",
    }),
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  }).then((response) => {
    window.location.href = getAfterSignOutPath();
  });
};

export default logout;
